import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Store } from '@ngxs/store';
import { UserState } from 'src/app/_user/store/user/user.state';

@Directive({
    selector: '[appHasModule]',
    standalone: false
})
export class HasModuleDirective {

    modulesList: string[] = [];

    constructor(private readonly store: Store,
                private readonly viewContainerRef: ViewContainerRef,
                private readonly templateRef: TemplateRef<any>) {
        this.modulesList = this.store.selectSnapshot(UserState.modulesList);
    }

    @Input()
    set appHasModule(modules: string | string[]) {
        const hasModules = this.store.selectSnapshot(UserState.hasModules(modules));

        if (hasModules) {
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        } else {
            this.viewContainerRef.clear();
        }
    }

}
